<template>
    <div class="hello">
    	test
		<p>{{ $t('language.name') }}</p>
		<p>{{ $t('navbar.contact') }}</p>
    </div>
</template>

<script>
export default {
    name: 'HelloWorld',
    data () {
        return {
            msg: 'Welcome to Your Vue.js App'
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/HelloWorld.vue